import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchTopUsers } from "../../../store/actions/userVerifyActions";

function TopUsersMini() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { topUsers, topUsersLoading } = useSelector((state) => state.verify);

    useEffect(() => {
        const deviceToken = localStorage.getItem("deviceToken");
        if (deviceToken) {
            dispatch(fetchTopUsers(deviceToken));
        }
    }, [dispatch]);

    const users =
        topUsers && Array.isArray(topUsers.top_users)
            ? topUsers.top_users.slice(0, 3)
            : [];

    return (
        <div className="w-full h-full flex flex-col p-[2.4vh_1.8vw]">
            <span className="text-[1.3vh] font-bold tracking-[0.15vh] uppercase text-[#7B8290]">
                {t("routeList.top_users_label")}
            </span>

            <div className="flex-1 min-h-0 flex flex-col justify-center gap-[1.6vh] mt-[1.2vh]">
                {topUsersLoading && users.length === 0 ? (
                    <span className="text-[1.6vh] font-semibold text-[#7B8290]">
                        {t("routeList.top_users_loading")}
                    </span>
                ) : users.length === 0 ? (
                    <span className="text-[1.6vh] font-semibold text-[#7B8290]">
                        {t("routeList.top_users_empty")}
                    </span>
                ) : (
                    users.map((user, i) => (
                        <div key={i} className="flex items-center gap-[1.2vw]">
                            <span
                                className={`w-[3vh] h-[3vh] rounded-full flex items-center justify-center text-[1.4vh] font-bold flex-none ${
                                    i === 0
                                        ? "bg-[#E3ECFB] text-[#246CE2]"
                                        : "bg-[#F1F3F7] text-[#7B8290]"
                                }`}
                            >
                                {i + 1}
                            </span>
                            <span className="flex-1 min-w-0 truncate text-[1.8vh] font-semibold">
                                {user.username}
                            </span>
                            <span className="text-[1.4vh] font-semibold text-[#7B8290] flex-none">
                                {user.total_prints} {t("routeList.top_users_pages")}
                            </span>
                        </div>
                    ))
                )}
            </div>

            <span className="text-[1.3vh] font-semibold text-[#7B8290] mt-auto">
                {t("routeList.top_users_period")}
            </span>
        </div>
    );
}

export default TopUsersMini;
